module.exports = __webpack_public_path__ + "static/media/BariolBold-Italic.2e06f9a0.woff2";